import { Col, ColProps } from '@opendoor/bricks-next';

export function FCContentContainer({ children, ...rest }: ColProps) {
  const { $largerThanMD, ...restProps } = rest;

  return (
    <Col
      paddingHorizontal="$12x"
      $largerThanMD={{
        maxWidth: 1400,
        paddingHorizontal: '$40x',
        ...$largerThanMD,
      }}
      width="100%"
      flex={1}
      {...restProps}
    >
      {children}
    </Col>
  );
}

export function FCContentContainerWrapper({ children, ...rest }: ColProps) {
  return (
    <Col width="100%" alignItems="center" {...rest}>
      {children}
    </Col>
  );
}
